// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cFyc","clinicsSelect":"styles_clinicsSelect__1fvT0"};